import React from 'react'
import { CountryDropdownItem } from '@carsys/form/src/CountriesDropdownBase'
import { TicketContactPreference, TicketType } from '@cbgms/api'

export interface ITicketFormContextExpose {
  isAvailable: boolean // set to false when this feature is off for the current wholesaler
  ticketType: TicketType
  contactPreference: TicketContactPreference
  vehicleCountry: string
  clearPartValues: () => void
  clearVehicleValues: () => void
  CountriesOptionsWrapper: React.FC<{ children: (countryOptions: CountryDropdownItem[]) => JSX.Element }>
}

export const TicketFormContext = React.createContext<ITicketFormContextExpose | undefined>(undefined)

export const useTicketFormContext = () => {
  const context = React.useContext(TicketFormContext)
  if (context === undefined) {
    throw new Error('useTicketFormContext must be used within a TicketFormContext')
  }
  return context
}
